// extracted by mini-css-extract-plugin
export var button = "Button-module--button--12841";
export var icon = "Button-module--icon--1b1ac";
export var largeButton = "Button-module--largeButton--97fd6";